import { forwardRef } from 'react';

import classNames from 'classnames';
import PropTypes from 'prop-types';

import { ReactComponent as SearchIcon } from 'images/Icons/Search.svg';

import styles from './SearchInput.module.scss';

const SearchInput = forwardRef(
  ({ name, placeholder = 'Search', onChange, className }, ref) => (
    <div
      className={classNames(styles.wrapper, className)}
      data-testid="search-input-wrapper"
    >
      <input
        ref={ref}
        name={name}
        placeholder={placeholder}
        onChange={onChange}
        data-testid="search-input-root"
      />
      <SearchIcon data-testid="search-input-icon" />
    </div>
  ),
);

SearchInput.propTypes = {
  name: PropTypes.string,
  placeholder: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  className: PropTypes.string,
};

SearchInput.displayName = 'SearchInput';

export default SearchInput;
